/**
 * Auth Selectors
 * Provides typed selectors for accessing auth state
 */

import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../index';

export const selectAuth = (state: RootState) => state.auth;

export const selectIsAuthenticated = createSelector([selectAuth], (auth) => auth.authenticated);

export const selectFirebaseUid = createSelector([selectAuth], (auth) => auth.firebase_uid);

export const selectJwtToken = createSelector([selectAuth], (auth) => auth.jwt_token);

export const selectUser = createSelector([selectAuth], (auth) => auth.user);

export const selectAuthLoading = createSelector([selectAuth], (auth) => auth.loading);

export const selectAuthError = createSelector([selectAuth], (auth) => auth.error);

